export function getSearchedSourcesLabel(sourceCount: number): string {
  if (sourceCount === 1) {
    return window.i18next.t('pmwjs_ai_chat_web_sources_searched_one');
  }

  return window.i18next.t('pmwjs_ai_chat_web_sources_searched_other', {count: sourceCount});
}
